import PageSubHeader from './PageSubHeader';

export default PageSubHeader;
export { PageSubHeader };
